import { z } from 'zod';
import { BaseStatFilterSchema } from '../../../schemas';
import { useAdmissionMethodsLineChartQuery, useAdmissionMethodsStackedBarChartQuery } from './useAdmissionMethodsQuery';

interface UseAdmissionMethodsChartParams {
	filters?: z.infer<typeof BaseStatFilterSchema>;
}

export const useAdmissionMethodsLineChart = (params?: UseAdmissionMethodsChartParams) => {
	const { data: nivoData, isLoading, error } = useAdmissionMethodsLineChartQuery(params);

	return {
		nivoData: nivoData?.data || null,
		isLoading,
		error
	};
};


export const useAdmissionMethodsStackedBarChart = (params?: UseAdmissionMethodsChartParams) => {
	const { data: nivoData, isLoading, error } = useAdmissionMethodsStackedBarChartQuery(params);

	return {
		nivoData: nivoData?.data || null,
		isLoading,
		error
	};
};
